
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/zebra",
      function () {
        return require("private-next-pages/products/zebra/index.tsx");
      }
    ]);
  